import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import { useAuth } from 'react-oidc-context';
import { ISSUER } from '../../auth-config';
import { baseUrl } from '../../config.js'
import { formatoFechaCorta } from "../../almacen.js";
import useToken from '../../useToken';
import './Cuenta.css';
import { initializeNotifications, requestPermission, unsubscribe } from '../../firebase.js';
import Perfiles from "./Perfiles.jsx";
import { compressImageFile, exportCircularCrop, loadImageFromFile } from '../../utils/imageProcess.js';

import defaultPersona from '../../img/nombre.png';
import Quitar from '../../img/Cerrar.png';
import Aprobar from "../../img/Aprobar.png";
import Cargando from "../../img/Cargando.gif";
import Ver from '../../img/ver.png';
import Ocultar from '../../img/ocultar.png';
import Checked from '../../img/Checked.png';

const Cuenta = ({setUser})=>{
	const auth = useAuth();

	const {token} = useToken();
	const [datos, setDatos] = useState({});
	const [pass, setPass] = useState('');
	const [mostrar, setMostrar] = useState(false);
	const [editar, setEditar] = useState({});
	const [float, setFloat] = useState({});
	const [disabled, setDisabled] = useState(false);
	const [foto, setFoto] = useState({});
	const fotoEditorRef = useRef(null);
	const [notificaciones, setNotificaciones] = useState({
		push: false,
		email: false,
		whatsapp: false
	});
	const [cargandoNotif, setCargandoNotif] = useState(false);
	
	const contraseñaRef = useRef();
	const actualRef = useRef();
	const confirmarRef = useRef();
	const telefonoRef = useRef();
	const correoRef = useRef();
	const nombreRef = useRef();
	const apellidoRef = useRef();
	const fechaRef = useRef();

	const longitudMinima = new RegExp('.{8,}');
    const contieneNumero = new RegExp('\\d');
    const contieneMinuscula = new RegExp('[a-z]');
    const contieneMayuscula = new RegExp('[A-Z]');
    const contieneCaracterEspecial = new RegExp('[^a-zA-Z\\d\\s:]');
    const contador = 60;

	useEffect(()=>{
		if(token)
            getData();
	},[token])

	const getData = async ()=>{
		try {
			const response = await fetch(baseUrl+"User", {
				headers:{
					'Authorization': `Bearer ${token}`,
				}
			});
			const result = await response.json().catch(() => null);
			console.log(result);
			if (result?.success && result.data) {
				setDatos(result.data);
				setFoto({url: result.data?.url})
				setNotificaciones({
					push: result.data?.pushNotification,
					email: result.data?.emailNotification,
					whatsapp: result.data?.whatsappNotification
				})
			}
		} catch (error) {
			console.error(error);
		}
	}

	const guardarFoto = async (e, boton)=>{
		if(boton && e?.target) e.target.disabled = true;
		setFloat({ estado: 'guardando', mensaje: 'Guardando foto…' });
		try {
			let fileToUpload = null;

			if (fotoEditorRef.current?.getCroppedFile) {
				const cropped = await fotoEditorRef.current.getCroppedFile();
				if (cropped?.file) fileToUpload = cropped.file;
			}
			if (!fileToUpload && foto.file) fileToUpload = foto.file;

			if (!fileToUpload) {
				setFloat({ estado: 'error', mensaje: 'Selecciona una foto antes de guardar.' });
				return;
			}

			const data = new FormData();
			data.append('file', fileToUpload);

			const response = await fetch(baseUrl + 'User/Photo', {
				method: 'post',
				headers: {
					Accept: 'application/json',
					Authorization: `Bearer ${token}`,
				},
				body: data,
			});
			const json = await response.json().catch(() => ({}));

			if (!response.ok || !json?.success || !json?.newUrl) {
				throw new Error(json?.error || 'No se pudo guardar la foto');
			}

			setEditar((prev) => ({ ...prev, foto: false }));
			setDatos((prev) => ({ ...prev, url: json.newUrl }));
			setFoto({ url: json.newUrl });
			setUser((user) => ({ ...user, url: json.newUrl }));
			setFloat({ estado: 'listo', mensaje: 'Foto actualizada' });
			setTimeout(() => setFloat({}), 3500);
		} catch (error) {
			console.error(error);
			setFloat({
				estado: 'error',
				mensaje: error?.message || 'Error al guardar la foto',
			});
			setTimeout(() => setFloat({}), 6000);
		} finally {
			if (boton && e?.target) e.target.disabled = false;
		}
	}

	const guardarDatos = async (e, boton)=>{
		if(boton)
			e.target.disabled = true;
		setFloat({estado:'guardando', mensaje:'Guardando...'})
		console.log(nombreRef.current.value.trim())
		if(nombreRef.current.value.trim() == ""){
			setFloat({estado:'error', mensaje:'Ingresa el nombre.'})
			setTimeout(()=>{
				if(boton)
					e.target.disabled = false;
				setFloat({})
			},5000)
			return false;
		}
		else if(apellidoRef.current.value.trim() == ""){
			setFloat({estado:'error', mensaje:'Ingresa el apellido.'})
			setTimeout(()=>{
				if(boton)
					e.target.disabled = false;
				setFloat({})
			},5000)
			return false;
		}
		else if(fechaRef.current.value.trim() == ""){
			setFloat({estado:'error', mensaje:'Ingresa una fecha de nacimiento.'})
			setTimeout(()=>{
				if(boton)
					e.target.disabled = false;
				setFloat({})
			},5000)
			return false;
		}

		const data = {
			name: nombreRef.current.value,
			lastname: apellidoRef.current.value,
			birthdate: fechaRef.current.value,
			cellphone: telefonoRef.current?.value?.trim() || datos?.cellphone || '',
			email: correoRef.current?.value?.trim() || datos?.email || '',
			pushNotification: notificaciones.push ? 1 : 0,
			emailNotification: notificaciones.email ? 1 : 0,
			whatsappNotification: notificaciones.whatsapp ? 1 : 0
		}

		// Amplify: actualizar teléfono si fue modificado
		if(telefonoRef.current?.value?.trim() && telefonoRef.current.value.trim() !== datos?.cellphone){
			try { accionDeIdentidad('PERFIL'); }
			catch(err){ console.log(err); }
		}
		// Amplify: actualizar correo si fue modificado
		if(correoRef.current?.value?.trim() && correoRef.current.value.trim() !== datos?.email){
			try { accionDeIdentidad('PERFIL'); }
			catch(err){ console.log(err); }
		}
		
		const result = await fetch(baseUrl+"User", {
			method: 'put',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
		.then(response=>response.json())
		.then(json=>{
			console.log(json)
			setFloat({estado:'listo', mensaje:'¡Listo! Se han guardado los cambios con éxito'})
			setDatos({...datos, ...data})
			setEditar({...editar, datos: false})
			if(boton){
				e.target.disabled = false;
			}
			else{
				if(boton)
					e.target.disabled = false;
			}
			setTimeout(() => {
				setFloat({});
			}, 5000);
			return true;
		})
		.catch(error=>{
			console.error(error);
			setFloat({estado:'error', mensaje:error})
			setTimeout(()=>{
				if(boton)
					e.target.disabled = false;
				setFloat({})
			},5000)
			return false;
		})
	}

	const guardarPassword = async (e, boton)=>{
		try {
			const actual = actualRef.current.value;
			const nueva = contraseñaRef.current.value;
			const confirmar = confirmarRef.current.value;
			if(!(
				actualRef.current.reportValidity() &&
				contraseñaRef.current.reportValidity() &&
				confirmarRef.current.reportValidity()
			))
				return false;
			if(!contraseñaRef.current.reportValidity()){
				setFloat({estado:'error', mensaje:'La nueva contraseña no cumple con las condiciones.'})
				setTimeout(() => {
					setFloat({});
				}, 5000);
				return false;
			}
			if(nueva != confirmar){
				setFloat({estado:'error', mensaje:'La nueva contraseña no coincide.'})
				setTimeout(() => {
					setFloat({});
				}, 5000);
				return false;
			}
			accionDeIdentidad('UPDATE_PASSWORD');
		} catch (err) {
			console.log(err);
		}
		
	}

	// Correo, telefono y contrasena son datos de identidad: con Keycloak los
	// gobierna el proveedor, no la app. Cambiarlos desde aqui exigiria la API de
	// cuenta de Keycloak y reimplementar su verificacion; mandarlo a su consola
	// es mas corto y no duplica reglas.
	//
	// kc_action hace que Keycloak pida justo esa accion y devuelva al usuario.
	const accionDeIdentidad = (accion)=>{
		if(accion === 'UPDATE_PASSWORD'){
			auth.signinRedirect({ extraQueryParams: { kc_action: 'UPDATE_PASSWORD' } });
			return;
		}
		window.open(`${ISSUER}/account/#/personal-info`, '_blank', 'noopener');
	};

	const guardarAtributo = async (attributeKey, e, boton)=>{
		if(boton)
			e.target.disabled = true;
		setFloat({estado:'guardando', mensaje:'Guardando...'})
		
		let value = '';

		if(attributeKey == 'phone_number'){
			if(telefonoRef.current.value.trim() == ""){
				setFloat({estado:'error', mensaje:'Ingresa el Teléfono.'})
				setTimeout(()=>{
					if(boton)
						e.target.disabled = false;
					setFloat({})
				},5000)
				return false;
			}
			value = "+52"+telefonoRef.current.value;
		}
		else{
			if(correoRef.current.value.trim() == ""){
				setFloat({estado:'error', mensaje:'Ingresa el Correo Electronico.'})
				setTimeout(()=>{
					if(boton)
						e.target.disabled = false;
					setFloat({})
				},5000)
				return false;
			}
			value = correoRef.current.value;
		}

		try {
			// attributeKey y value siguen calculandose arriba porque la
			// validacion del formulario los usa; el cambio en si lo hace el
			// usuario en la consola de Keycloak.
			console.log('identidad delegada a Keycloak:', attributeKey, value);
			accionDeIdentidad('PERFIL');
			// handleUpdateUserAttributeNextSteps(output);
		  } catch (error) {
			console.log(error);
		  }
		
		const result = await fetch(baseUrl+"User", {
			method: 'put',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			},
			body: JSON.stringify(datos),
		})
		.then(response=>response.json())
		.then(json=>{
			console.log(json)
			setFloat({estado:'listo', mensaje:'¡Listo! Se han guardado los cambios con éxito'})
			if(boton){
				e.target.disabled = false;
			}
			else{
				if(boton)
					e.target.disabled = false;
			}
			setTimeout(() => {
				setFloat({});
			}, 5000);
			return true;
		})
		.catch(error=>{
			console.error(error);
			setFloat({estado:'error', mensaje:error})
			setTimeout(()=>{
				if(boton)
					e.target.disabled = false;
				setFloat({})
			},5000)
			return false;
		})
	}

	const validaInput = ()=>{

	}

	return(
		<div className="persona miPerfil">
			{float?.estado &&
				<div className={"float"+(" "+float.estado)}>
					<div className="mensaje">{float.mensaje}</div>
				</div>
			}

			{/* ── Hero: avatar + nombre ── */}
			<div className="perfilHero">
				<div className="avatarWrap">
					<Foto
						ref={fotoEditorRef}
						foto={foto}
						setFoto={setFoto}
						editar={editar?.foto || false}
						onSave={() => guardarFoto(null, false)}
						onCancel={() => setEditar((prev) => ({ ...prev, foto: false }))}
					/>
					{!editar?.foto &&
						<button type="button" className="heroEditFotoBtn" onClick={()=>setEditar({...editar, foto:true})}>
							<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>
						</button>
					}
				</div>
				<div className="perfilHeroInfo">
					<div className="perfilHeroNombre">{datos?.name ? `${datos.name} ${datos.lastname || ''}`.trim() : 'Mi Perfil'}</div>
					{datos?.email && <div className="perfilHeroEmail">{datos.email}</div>}
				</div>
			</div>

			<form>
			<div className="perfilCards">

				{/* ── Card: Datos Personales ── */}
				<div className="perfilCard">
					<div className="perfilCardHeader">
						<span className="perfilCardIcon azul"><svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg></span>
						<h3>Datos Personales</h3>
						<button type='button' className={`editarBtn${editar?.datos ? ' guardar' : ''}`} onClick={()=>{
							if(editar?.datos) guardarDatos();
							else setEditar({...editar, datos: true});
						}}>{editar?.datos ? 'Guardar' : 'Editar'}</button>
					</div>
					<div className="perfilCardBody">
						{editar?.datos ? (
							<>
								<label>
									<input type='text' ref={nombreRef} placeholder=' ' defaultValue={datos?.name} onChange={validaInput} minLength={1} required/>
									<span>Nombre(s)</span>
								</label>
								<label>
									<input type='text' ref={apellidoRef} placeholder=' ' defaultValue={datos?.lastname} onChange={validaInput} minLength={1} required/>
									<span>Apellido(s)</span>
								</label>
								<label>
									<input type='date' ref={fechaRef} placeholder=' ' defaultValue={datos?.birthdate} onChange={validaInput} required/>
									<span>Fecha de Nacimiento</span>
								</label>
								<label>
									<input type='tel' ref={telefonoRef} placeholder=' ' defaultValue={datos?.cellphone} onChange={validaInput} disabled={disabled}/>
									<span>Teléfono</span>
								</label>
								<label>
									<input type='email' ref={correoRef} placeholder=' ' defaultValue={datos?.email} onChange={validaInput} disabled={disabled}/>
									<span>Correo Electrónico</span>
								</label>
							</>
						) : (
							<>
								<div className="infoDato"><span>Nombre(s)</span><span>{datos?.name || '---'}</span></div>
								<div className="infoDato"><span>Apellido(s)</span><span>{datos?.lastname || '---'}</span></div>
								<div className="infoDato"><span>Fecha de Nacimiento</span><span>{datos?.birthdate ? formatoFechaCorta(new Date(datos?.birthdate.split("-"))) : '---'}</span></div>
								<div className="infoDato"><span>Teléfono</span><span>{datos?.cellphone || '---'}</span></div>
								<div className="infoDato"><span>Correo</span><span>{datos?.email || '---'}</span></div>
							</>
						)}
					</div>
				</div>

				{/* ── Card: Contraseña ── */}
				<div className="perfilCard">
					<div className="perfilCardHeader">
						<span className="perfilCardIcon morado"><svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></span>
						<h3>Contraseña</h3>
						<button type='button' className={`editarBtn${editar?.contraseña ? ' guardar' : ''}`} onClick={()=>{
							if(editar?.contraseña) guardarPassword();
							else setEditar({...editar, contraseña: true});
						}}>{editar?.contraseña ? 'Guardar' : 'Editar'}</button>
					</div>
					<div className="perfilCardBody">
						{editar?.contraseña ? (
							<>
								<label>
								<input type='password' ref={actualRef} placeholder=' ' onChange={validaInput} minLength={1} required disabled={disabled}/>
								<span>Contraseña Actual</span>
								</label>
								<div className="passGroup">
								<label className="lblPass">
								<input type={mostrar ? 'text' : 'password'}
									ref={contraseñaRef}
									placeholder=' '
									minLength={1}
									pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d\s:]).{8,}$"
									onChange={(e)=>{ setPass(e.target.value); validaInput(e); }}
									required/>
								<span>Nueva Contraseña</span>
								<button className="mostrarPass" tabIndex={-1} type="button" onClick={()=>setMostrar(!mostrar)}>
									<img src={mostrar ? Ocultar : Ver}/>
								</button>
								</label>
								<div className="reqPass">
									<div><b>La contraseña debe incluir</b></div>
									<div><span className="check">{longitudMinima.test(pass) && <img src={Aprobar}/>}</span><span>Al menos <b>8 caracteres</b></span></div>
									<div><span className="check">{contieneNumero.test(pass) && <img src={Aprobar}/>}</span><span>Al menos <b>1 número</b></span></div>
									<div><span className="check">{contieneMinuscula.test(pass) && <img src={Aprobar}/>}</span><span>Al menos una <b>letra minúscula</b></span></div>
									<div><span className="check">{contieneMayuscula.test(pass) && <img src={Aprobar}/>}</span><span>Al menos una <b>letra mayúscula</b></span></div>
									<div><span className="check">{contieneCaracterEspecial.test(pass) && <img src={Aprobar}/>}</span><span>Al menos <b>1 carácter especial</b></span></div>
									<div>{`^ $ * . [ ] { } ( ) ? - " ! @ # % & / \\ , > < ' : ; | _ ~ \` + =`}</div>
								</div>
								</div>
								<label>
								<input type='password' ref={confirmarRef} placeholder=' ' onChange={validaInput} minLength={1} required disabled={disabled}/>
								<span>Confirmar Nueva Contraseña</span>
								</label>
							</>
						) : (
							<div className="infoDato"><span>Contraseña</span><span>{'••••••••'}</span></div>
						)}
					</div>
				</div>

				{/* ── Card: Notificaciones ── */}
				<div className="perfilCard">
					<div className="perfilCardHeader">
						<span className="perfilCardIcon azul"><svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg></span>
						<h3>Notificaciones</h3>
						<button type='button' className={`editarBtn${editar?.notificaciones ? ' guardar' : ''}`} onClick={async (e)=>{
							if(editar?.notificaciones){
								setCargandoNotif(true);
								try {
									const data = {
										pushNotification: notificaciones.push ? 1 : 0,
										emailNotification: notificaciones.email ? 1 : 0,
										whatsappNotification: notificaciones.whatsapp ? 1 : 0
									};
									const result = await fetch(baseUrl+"User", {
										method: 'put',
										headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': `Bearer ${token}` },
										body: JSON.stringify(data),
									}).then(r=>r.json());
									if(result.success){
										setFloat({estado:'listo', mensaje:'¡Listo! Se han guardado los cambios con éxito'});
										setDatos(d=>({...d, ...data}));
										if(!notificaciones.push) unsubscribe();
										setEditar({...editar, notificaciones: false});
									} else {
										setFloat({estado:'error', mensaje: result.message || 'Error al guardar'});
									}
								} catch(err){
									setFloat({estado:'error', mensaje: err.message || 'Error al guardar'});
								}
								setCargandoNotif(false);
							} else {
								setEditar({...editar, notificaciones: true});
							}
						}}>{editar?.notificaciones ? 'Guardar' : 'Editar'}</button>
					</div>
					<div className="perfilCardBody">
						{editar?.notificaciones ? (
							<div className="contNotificaciones">
								<div className="opcion notification-option" style={{opacity: cargandoNotif ? 0.7 : 1, pointerEvents: cargandoNotif ? 'none' : 'auto'}}>
									<label className="switch">
										<input type="checkbox" id="push" checked={notificaciones.push} onChange={(e)=>setNotificaciones({...notificaciones, push: e.target.checked})} disabled={cargandoNotif}/>
										<span><span className="bola"><img src={Checked}/></span></span>
									</label>
									<label htmlFor="push">Notificaciones Push</label>
								</div>
								<div className="opcion notification-option" style={{opacity: cargandoNotif ? 0.7 : 1, pointerEvents: cargandoNotif ? 'none' : 'auto'}}>
									<label className="switch">
										<input type="checkbox" id="email" checked={notificaciones.email} onChange={(e)=>setNotificaciones({...notificaciones, email: e.target.checked})} disabled={cargandoNotif || !datos?.email}/>
										<span><span className="bola"><img src={Checked}/></span></span>
									</label>
									<label htmlFor="email">Notificaciones por Email</label>
									{!datos?.email && <span style={{color:'#c03030', fontSize:'0.78em', marginLeft:6}}>Agrega tu correo para activar</span>}
								</div>
								<div className="opcion notification-option" style={{opacity: cargandoNotif ? 0.7 : 1, pointerEvents: cargandoNotif ? 'none' : 'auto'}}>
									<label className="switch">
										<input type="checkbox" id="whatsapp" checked={notificaciones.whatsapp} onChange={(e)=>setNotificaciones({...notificaciones, whatsapp: e.target.checked})} disabled={cargandoNotif || !datos?.cellphone}/>
										<span><span className="bola"><img src={Checked}/></span></span>
									</label>
									<label htmlFor="whatsapp">Notificaciones por WhatsApp</label>
									{!datos?.cellphone && <span style={{color:'#c03030', fontSize:'0.78em', marginLeft:6}}>Agrega tu teléfono para activar</span>}
								</div>
							</div>
						) : (
							<div className="statusNotificaciones">
								<div className="notifRow"><span>Push</span><span className={`notifPill ${notificaciones.push ? 'on' : 'off'}`}>{notificaciones.push ? 'Activadas' : 'Desactivadas'}</span></div>
								<div className="notifRow"><span>Email</span><span className={`notifPill ${notificaciones.email ? 'on' : 'off'}`}>{notificaciones.email ? 'Activadas' : 'Desactivadas'}</span></div>
								<div className="notifRow"><span>WhatsApp</span><span className={`notifPill ${notificaciones.whatsapp ? 'on' : 'off'}`}>{notificaciones.whatsapp ? 'Activadas' : 'Desactivadas'}</span></div>
							</div>
						)}
					</div>
				</div>

			</div>
			</form>

			<Perfiles/>

		</div>
	);
}

const VIEWPORT = 140;

const Foto = forwardRef(({ foto, setFoto, editar, onSave, onCancel }, ref) => {
	const [error, setError] = useState({});
	const [procesando, setProcesando] = useState(false);
	const [sourceUrl, setSourceUrl] = useState('');
	const [imgSize, setImgSize] = useState({ w: 0, h: 0 });
	const [offset, setOffset] = useState({ x: 0, y: 0 });
	const [zoom, setZoom] = useState(1);
	const input = useRef();
	const dragRef = useRef(null);
	const imageRef = useRef(null);
	const offsetRef = useRef(offset);
	const zoomRef = useRef(zoom);
	const fileRef = useRef(null);

	offsetRef.current = offset;
	zoomRef.current = zoom;

	useImperativeHandle(ref, () => ({
		getCroppedFile: async () => {
			let image = imageRef.current;
			if (!image && fileRef.current) {
				image = await loadImageFromFile(fileRef.current);
				imageRef.current = image;
			}
			if (!image) return null;
			return exportCircularCrop({
				image,
				viewportSize: VIEWPORT,
				offset: offsetRef.current,
				zoom: zoomRef.current,
				outputSize: 512,
				quality: 0.85,
				fileName: 'perfil.jpg',
			});
		},
	}));

	useEffect(() => {
		if (!editar) {
			if (sourceUrl && sourceUrl.startsWith('blob:')) URL.revokeObjectURL(sourceUrl);
			setSourceUrl('');
			imageRef.current = null;
			fileRef.current = null;
			setOffset({ x: 0, y: 0 });
			setZoom(1);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [editar]);

	const baseScale = imgSize.w && imgSize.h
		? Math.max(VIEWPORT / imgSize.w, VIEWPORT / imgSize.h)
		: 1;
	const displayScale = baseScale * zoom;

	const aplicarArchivo = async (file) => {
		if (!file) return;
		if (file.size / (1024 * 1024) > 25) {
			setError({ error: true, descripcion: 'La imagen no debe ser mayor a 25MB' });
			return;
		}
		setError({});
		setProcesando(true);
		try {
			const { file: compressed, img } = await compressImageFile(file, {
				maxSide: 1600,
				quality: 0.82,
			});
			if (sourceUrl && sourceUrl.startsWith('blob:')) URL.revokeObjectURL(sourceUrl);
			const url = URL.createObjectURL(compressed);
			imageRef.current = img;
			fileRef.current = compressed;
			setImgSize({ w: img.width, h: img.height });
			setSourceUrl(url);
			setOffset({ x: 0, y: 0 });
			setZoom(1);
			setFoto({ url, file: compressed, editable: true });
		} catch (err) {
			console.error(err);
			setError({ error: true, descripcion: 'No se pudo procesar la imagen' });
		} finally {
			setProcesando(false);
		}
	};

	const selecciona = () => input.current?.click();

	const onPointerDown = (e) => {
		if (!sourceUrl) return;
		e.currentTarget.setPointerCapture(e.pointerId);
		dragRef.current = {
			startX: e.clientX,
			startY: e.clientY,
			origX: offsetRef.current.x,
			origY: offsetRef.current.y,
		};
	};

	const onPointerMove = (e) => {
		if (!dragRef.current) return;
		const dx = e.clientX - dragRef.current.startX;
		const dy = e.clientY - dragRef.current.startY;
		setOffset({
			x: dragRef.current.origX + dx,
			y: dragRef.current.origY + dy,
		});
	};

	const onPointerUp = (e) => {
		if (!dragRef.current) return;
		try { e.currentTarget.releasePointerCapture(e.pointerId); } catch (_) {}
		dragRef.current = null;
	};

	const onDropFile = (e) => {
		e.currentTarget.classList.remove('hov');
		e.preventDefault();
		e.stopPropagation();
		const file = e.dataTransfer?.files?.[0];
		if (file) aplicarArchivo(file);
	};

	const limpiar = () => {
		if (sourceUrl && sourceUrl.startsWith('blob:')) URL.revokeObjectURL(sourceUrl);
		setSourceUrl('');
		imageRef.current = null;
		fileRef.current = null;
		setFoto({});
		setOffset({ x: 0, y: 0 });
		setZoom(1);
		if (input.current) input.current.value = '';
	};

	if (!editar) {
		return (
			<div className="ver perfil">
				<img src={foto?.url || defaultPersona} alt="" />
			</div>
		);
	}

	const canPan = Boolean(sourceUrl);

	return (
		<div className="divFotoEdit">
			<input
				type="file"
				ref={input}
				accept="image/*"
				hidden
				onChange={(e) => aplicarArchivo(e.target.files?.[0])}
			/>

			{!foto?.url && !sourceUrl ? (
				<button
					type="button"
					className="fotoDropzone"
					onClick={selecciona}
					onDragOver={(e) => { e.preventDefault(); e.currentTarget.classList.add('hov'); }}
					onDragEnter={(e) => { e.preventDefault(); e.currentTarget.classList.add('hov'); }}
					onDragLeave={(e) => { e.preventDefault(); e.currentTarget.classList.remove('hov'); }}
					onDrop={onDropFile}
				>
					<span className="fotoDropzoneIcon" aria-hidden="true">
						<svg viewBox="0 0 24 24">
							<path d="M12 16V6" />
							<path d="m8 10 4-4 4 4" />
							<path d="M4 18h16" />
						</svg>
					</span>
					<span className="fotoDropzoneTitle">
						{procesando ? 'Comprimiendo…' : 'Subir foto'}
					</span>
					<span className="fotoDropzoneSub">Toca o arrastra aquí</span>
					{error.error && <span className="fotoDropzoneError">{error.descripcion}</span>}
				</button>
			) : (
				<div className="fotoCrop">
					<div
						className={'fotoCropViewport' + (canPan ? ' is-pan' : '')}
						style={{ width: VIEWPORT, height: VIEWPORT }}
						onPointerDown={canPan ? onPointerDown : undefined}
						onPointerMove={canPan ? onPointerMove : undefined}
						onPointerUp={canPan ? onPointerUp : undefined}
						onPointerCancel={canPan ? onPointerUp : undefined}
					>
						{canPan ? (
							<img
								src={sourceUrl}
								alt=""
								draggable={false}
								style={{
									width: imgSize.w * displayScale,
									height: imgSize.h * displayScale,
									transform: `translate(calc(-50% + ${offset.x}px), calc(-50% + ${offset.y}px))`,
								}}
							/>
						) : (
							<img src={foto?.url || defaultPersona} alt="" className="fotoCropStatic" />
						)}
						{procesando && <div className="fotoCropBusy">Comprimiendo…</div>}
					</div>

					{canPan && (
						<label className="fotoCropZoom">
							<span>Zoom</span>
							<input
								type="range"
								min="1"
								max="3"
								step="0.01"
								value={zoom}
								onChange={(e) => setZoom(Number(e.target.value))}
							/>
						</label>
					)}

					<p className="fotoCropHint">
						{canPan
							? 'Arrastra para centrar · ajusta el zoom'
							: 'Elige una foto nueva para centrarla'}
					</p>

					<div className="fotoCropActions">
						{canPan && (
							<button type="button" className="fotoCropBtn primary" onClick={onSave} disabled={procesando}>
								Guardar foto
							</button>
						)}
						<button type="button" className="fotoCropBtn" onClick={selecciona} disabled={procesando}>
							Cambiar
						</button>
						<button type="button" className="fotoCropBtn ghost" onClick={limpiar}>
							Quitar
						</button>
						<button type="button" className="fotoCropBtn ghost" onClick={onCancel}>
							Cancelar
						</button>
					</div>
				</div>
			)}
		</div>
	);
});

export default Cuenta;